import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private count = 0;
  readonly isLoading$ = new BehaviorSubject<boolean>(false);

  show(): void {
    this.count++;
    if (this.count === 1) this.isLoading$.next(true);
  }

  hide(): void {
    this.count = Math.max(0, this.count - 1);
    if (this.count === 0) this.isLoading$.next(false);
  }
}
